import React from "react";
import { Helmet } from "react-helmet";

function FairUsagePolicy() {
  return (
    <>
      <Helmet>
        <title>Fair Usage Policy » ClubHosty</title>
        <link
          rel="canonical"
          href="https://www.clubhosty.com/fair-usage-policy"
        />
      </Helmet>
      <main id="main">
        <section className="breadcrumbs">
          <div className="container">
            <div>
              <h2>FUP Policy</h2>
              <center>
                {" "}
                <p>
                  The concept of Fair Usage Policy was introduced for the
                  customers who use resources beyond their limits. It’s better
                  to use the allotted amount rather than pushing your limits.
                </p>
              </center>
            </div>
          </div>
        </section>

        {/* ======= Services Section =======  */}
        <section id="services" className="services">
          <div className="container">
            <div className="row">
              <div className="col-md-12 section-heading">
                <h5>What "Unlimited" means?</h5>
                <p>
                  In hosting environments, a server's resources are what
                  economists would call a common pool resource, meaning that
                  although having plenty of available system resources benefits
                  everyone, no single user has an incentive to ensure that they
                  don't use too many resources themselves.
                </p>
                <p>
                  Forums and any applications using a commenting system should
                  have some form of spam protection or moderation. CAPTCHA is a
                  popular way to eliminate spam robots from spamming your
                  website.
                </p>
                <p>
                  Unlimited Disk Space/Bandwidth/Website Plans. This means that
                  we do not set a limit on the amount of bandwidth, websites or
                  disk space you may use in the normal operation of a personal
                  or small business website, provided it complies with this
                  Agreement. However, in the event your service usage or content
                  presents a risk to the stability, performance or uptime of our
                  servers, data storage, networking or other infrastructure, you
                  may be required to upgrade to a VPS, or we may take action to
                  restrict the resources your website is utilizing.
                </p>
              </div>
              <div id="nav-id-1" className="pt-5 section-heading">
                <h5>General</h5>
                <p>
                  <i className="fa fa-angle-double-right"></i> Search Engine
                  Optimization (SEO) farms or similar are strictly forbidden on
                  Clubhosty's servers and networks. SEO farms create undue
                  strain and resource abuse on any given server and affect all
                  clients.
                </p>
                <p>
                  <i className="fa fa-angle-double-right"></i> Banner rotation
                  services and link exchange networks are not permitted.
                </p>
                <p>
                  <i className="fa fa-angle-double-right"></i> Offering Image,
                  File, Document and Data storage, and free hosting and email
                  services are strictly prohibited.
                </p>
                <p>
                  <i className="fa fa-angle-double-right"></i> Off-site media
                  storage is not permitted.
                </p>
                <p>
                  <i className="fa fa-angle-double-right"></i> Operating a
                  public mirror site is not permitted.
                </p>
                <p>
                  <i className="fa fa-angle-double-right"></i> Running a proxy
                  or anonymizer, whether publicly accessible or protected, is
                  not permitted.
                </p>
                <p>
                  <i className="fa fa-angle-double-right"></i> Prime bank or
                  bank debenture-related sites, bitcoin sites, lottery sites,
                  muds or online RPGs, hate sites, hacker-related sites, sites
                  promoting illegal activity, IP scanner or other hacking tools,
                  mail bombing or spam scripts, or forums and websites that
                  distribute or promote warez content are expressly forbidden.
                </p>
                <p>
                  <i className="fa fa-angle-double-right"></i> Bittorrent
                  applications, trackers, and clients as well as any
                  file-sharing/peer-to-peer activities are forbidden.
                </p>
                <p>
                  <i className="fa fa-angle-double-right"></i> The operation of
                  gaming servers (such as but not limited to Minecraft,
                  Counter-Strike, Half-Life, battlefield1942) are forbidden.
                </p>
                <p>
                  <i className="fa fa-angle-double-right"></i> Web spiders and
                  indexers are not permitted.
                </p>
                <p>
                  <i className="fa fa-angle-double-right"></i> The
                  abovementioned services/web content create undue system load
                  on our servers and should only be run in a dedicated server
                  environment. All violations will be shut down immediately and
                  may result in account suspension and/or termination.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* End Services Section  */}
      </main>
      {/* End #main  */}
    </>
  );
}

export default FairUsagePolicy;
